// Module
var code = `<h2 class="font-lusitana mb-4 text-xl md:text-2xl">{{heading}}</h2>
<div class="flex grow flex-col justify-between rounded-xl bg-gray-50 p-4">
  <!-- Rows render into this slot from dashboard-invoices-latest-rows.tmpl.html
       — once at onRendered from birth data, and again whenever a later dump
       lands, so the list is never stale while mounted. -->
  <div class="bg-white px-6" data-slot="latest-rows"></div>

  <div class="flex items-center pb-2 pt-6">
    {{svgArrowPath}}
    <h3 class="ml-2 text-sm text-gray-500">{{updatedText}}</h3>
  </div>
</div>
`;
// Exports
module.exports = code;